@for (feat of features; track $index) {
  <h5>
    <!-- Technically the Feature and not the Geometry, but for UX -->
    <strong>Geometry #{{ feat.__geojsonIndex }}</strong>
  </h5>

  @if (feat.id) {
    <br />
    <h6>
      <strong>ID: {{ feat.id }}</strong>
    </h6>
  }

  <table>
    @for (prop of feat.properties | keyvalue: null; track $index) {
      <tr>
        <th valign="top">{{ prop.key }}</th>
        <td valign="top">
          <app-editable-array-or-object
            [value]="prop.value"
            [path]="[prop.key]"
            [feature]="feat"
            [isEditable]="isEditable"
          ></app-editable-array-or-object>
        </td>
      </tr>
    }
  </table>
  @if (features.length != 1 && features.length - 1 !== $index) {
    <hr />
  }
}
